import { query } from '@angular/animations';
import { Injectable } from '@angular/core';
import { GeneralApiEndpoints } from '@AppCore/constants/api-endpoints';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { HttpHelperService } from '@AppCore/services/http-helper.service';
import { environment } from '@Environments/environment';

@Injectable()
export class UtilityService {
  constructor(
    private http: HttpHelperService,
    private globalUtilityService: GlobalUtilityService
  ) {}

  getSearchedProducts(search: string) {
    const url = `${environment.BASE_URL}${GeneralApiEndpoints.SEARCH_SUGGESTIONS}`;
    return this.http.get(url, { search });
  }
}
